import * as React from "react";
import Layout from "layout/GlobalLayout";
import Routers from "./Routers";
import MenuItemsModule from "components/MenuItemsModule";
import { useTranslation } from "react-i18next";
import ErrorBoundary from "error/ErrorBoundary";
import MenuVertical from "layout/MenuVertical";

const Planning = ({ childrenMenu = [] }) => {
  const [t] = useTranslation("global");
  return (
    <Layout iconName={"planning"} textRoute={t("modules.title_planning")}>
      <div className="mt-3 lg:mt-10 flex flex-col items-center lg:items-baseline lg:flex-row gap-x-2 space-y-3 lg:space-y-0 lg:pt-0">
        <MenuVertical title={t("modules.title_planning")}>
          <ErrorBoundary>
            <MenuItemsModule items={childrenMenu} />
          </ErrorBoundary>
        </MenuVertical>
        <div className="overflow-x-hidden w-full">
          <ErrorBoundary>
            <Routers views={childrenMenu} />
          </ErrorBoundary>
        </div>
      </div>
    </Layout>
  );
};

export default Planning;
